const backend_url = process.env.REACT_APP_API_URL;
console.log({ backend_url });
export default backend_url;
